import * as React from "react";

function PhoneKeysIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M50.19 20.6a3.33 3.33 0 0 0-4.62.8l-1.9 2.71a3.31 3.31 0 0 0 .8 4.61c5.41 3.81 1.59 9.22-.31 11.93S38.44 48.76 33 45a3.31 3.31 0 0 0-4.61.8l-1.91 2.7a3.31 3.31 0 0 0 .8 4.61C34.07 57.83 40 58 49.57 44.46s7.43-19.09.62-23.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 20,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 6,
    height: 6
  }));
}

export default PhoneKeysIcon;